const entriesToObject:
<O = Object, T = unknown>() => [(obj: O, [key, value]: [string, T]) => O, O] = <O>() => [
  (obj, [key, value]) => ({ ...obj, [key]: value } as O),
  {} as O,
];

export default entriesToObject;
